import React, { useEffect, useState } from "react";
// import AddOfferModal from "./addOfferModal";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";

import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Container,
  Divider,
  Fab,
  Grid,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
// import { GetAllOffersApi } from "./GetAllOffersApi";
// import UpdateOfferModal from "./updateOfferModal";
import PluseIconn from "../../assets/img/icons/plus_icon.png";
import UpdateOfferModal from "../offers/updateOfferModal";
// import AddOfferModal from "../offers/addOfferModal";
import { GetAllOffersApi } from "../offers/GetAllOffersApi";
import UpdateAdvertisement from "./updateAdvertisement";
import AddOfferModal from "./addAdvertisement";
import {
  GetAllAdvertisement,
  GetAllMobileAdvertisement,
} from "./companyLoginApiHandler";
export const Advertisement = () => {
  const [open, setOpen] = useState(false);
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [data, setData] = useState([]);
  const [selectedOffer, setSelectedOffer] = useState(null);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleOpenUpdateModal = (offer = null) => {
    setSelectedOffer(offer);
    setOpenUpdateModal(true);
  };
  const handleCloseUpdateModal = () => {
    setSelectedOffer(null);
    setOpenUpdateModal(false);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0"); // Get day and add leading zero if needed
    const month = date.toLocaleString("default", { month: "short" }); // Get short month name (e.g., Sep)
    const year = date.getFullYear(); // Get full year (e.g., 2024)

    return `${day}-${month}-${year}`;
  };
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    const fetchAllOffers = async () => {
      try {
        let res =
          value === 0
            ? await GetAllAdvertisement()
            : await GetAllMobileAdvertisement();
        console.log("GetwebDeverti$$$$", res?.data.data.list);
        setData(res?.data.data.list);
      } catch (error) {
        console.error("Failed to fetch states:", error);
      }
    };

    fetchAllOffers();
  }, [open, openUpdateModal, value]);

  return (
    <>
      <Grid
        container
        sx={{
          py: 3,
          px: { xs: 2, sm: 3 },
          paddingTop: "15px",
          backgroundColor: "#E9E9FF",
          minHeight: "100vh",
        }}
      >
        <Grid
          item
          xs={12}
          md={8}
          sm={7}
          lg={9}
          sx={{
            background:
              "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
            padding: "10px",
            mt: "10px",
            borderRadius: "5px",
            color: "#01008B", // optional text color
            textAlign: "left",
            marginBottom: { sm: "10px", xs: "10px", md: "20px" },
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              paddingLeft: "10px",
              fontSize: { xs: "14px", sm: "14px", md: "15px" },
            }}
          >
            Advertisements
          </Typography>
        </Grid>
        <Grid
          item
          md={4}
          lg={3}
          sm={5}
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // paddingRight: "30px",
          }}
        >
          <Button
            onClick={() => setOpen(true)}
            variant="contained"
            fullWidth
            sx={{
              bgcolor: "#010093",
              fontWeight: 600,
              fontSize: "13px",
              display: "flex",
              height: "40px",
              alignItems: "center",
              gap: 2,
              marginBottom: { sm: "10px", xs: "5px" },
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
          >
            Add Advertisement
            <img
              src={PluseIconn}
              alt="plus"
              style={{ width: 18, height: 18 }}
            />
          </Button>
        </Grid>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          mt={{ xs: 0, sm: 2, md: 2, lg: 3 }}
          px={{ xs: 1, md: 3, sm: 1, lg: 20 }}
        >
          {/* Left Arrow Button */}

          {/* Tabs */}
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            centered
            sx={{
              "& .MuiTabs-flexContainer": {
                gap: { xs: 1, sm: 10, md: 20, lg: 20 }, // space between tabs
                py: 1.5, // vertical padding
              },
              "& .MuiTabs-indicator": {
                display: "none",
              },
            }}
          >
            <Tab
              value={0}
              label="Website"
              sx={{
                textTransform: "none",
                px: { xs: 2, sm: 4 },
                width: { xs: 150, sm: 250, md: 300, lg: 350 },
                fontWeight: 600,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                boxShadow: 1,
                borderRadius: 1,
                backgroundColor: "#fff",
                color: "#01008B",
                // fontSize: { xs: "13px", sm: "14px", md: "16px" },

                "&:hover": {
                  backgroundColor: "#e0e0e0",
                },
                "&.Mui-selected": {
                  backgroundColor: "#01008B",
                  color: "white",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
                },
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
            />
            <Tab
              value={1}
              label="Mobile Application"
              sx={{
                textTransform: "none",
                px: { xs: 1, sm: 4 },
                width: { xs: 150, sm: 250, md: 300, lg: 350 },
                fontWeight: 600,
                boxShadow: 1,
                borderRadius: 1,
                backgroundColor: "#fff",
                color: "#01008B",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },

                "&:hover": {
                  backgroundColor: "#e0e0e0",
                },
                "&.Mui-selected": {
                  backgroundColor: "#01008B",
                  color: "white",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
                },
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
            />
          </Tabs>
        </Box>
        <Grid
          item
          xs={12}
          mt={2}
          sx={{
            padding: "20px 10px",
            paddingTop: "30px",
            backgroundColor: "#fff",
            borderRadius: "10px",
          }}
        >
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sx={{
                height: "81vh",
                overflow: "auto",
                paddingX: "30px",
              }}
            >
              <Grid container spacing={3}>
                {data.map((item) => (
                  <Grid key={item.id} item lg={4} sm={6} xs={12}>
                    <Card
                      sx={{
                        backgroundColor: "#E9E9FF",
                        pt: "0px",
                        border: "2px solid #01008B",
                        p: 1.5,
                      }}
                    >
                      <CardContent sx={{ p: 0 }}>
                        <Stack>
                          <Typography
                            gutterBottom
                            variant="body2"
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              variant="body2"
                              component="span"
                              sx={{
                                color: "#000",
                                fontWeight: 600,
                                fontSize: 13,
                              }}
                            >
                              Start Date
                            </Typography>{" "}
                            <Typography
                              variant="body2"
                              component="span"
                              sx={{
                                color: "#01008B",
                                fontWeight: 500,
                                fontSize: 13,
                              }}
                            >
                              {/* 12/12/12 */}
                              {formatDate(item.fromDate)}
                            </Typography>{" "}
                          </Typography>
                          <Typography
                            gutterBottom
                            variant="body2"
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              variant="body2"
                              component="span"
                              sx={{
                                color: "#000",
                                fontWeight: 600,
                                fontSize: 13,
                              }}
                            >
                              End Date
                            </Typography>{" "}
                            <Typography
                              variant="body2"
                              component="span"
                              sx={{
                                color: "#01008B",
                                fontWeight: 500,
                                fontSize: 13,
                              }}
                            >
                              {/* 12-jan-3023 */}
                              {formatDate(item.toDate)}
                            </Typography>{" "}
                          </Typography>
                          <Typography
                            gutterBottom
                            variant="body2"
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              variant="body2"
                              component="span"
                              sx={{
                                color: "#000",
                                fontWeight: 600,
                                fontSize: 13,
                              }}
                            >
                              Status
                            </Typography>{" "}
                            <Typography
                              variant="body2"
                              component="span"
                              sx={{
                                color: "#01008B",
                                fontWeight: 500,
                                fontSize: 13,
                              }}
                            >
                              {/* Active */}
                              {item.status}
                            </Typography>{" "}
                          </Typography>
                        </Stack>
                      </CardContent>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-start",
                          px: 1,
                          pt: "4px",
                          pb: "4px",
                        }}
                      >
                        <Button
                          onClick={() => handleOpenUpdateModal(item)}
                          // onClick={() => handleOpenUpdateModal()}
                          endIcon={<EditIcon />}
                          variant="contained"
                          sx={{
                            width: "120px",
                            backgroundColor: "#01008B",
                            color: "white",
                            textTransform: "none",
                            fontWeight: 500,
                            "&:hover": {
                              backgroundColor: "#01008B",
                            },
                          }}
                        >
                          Edit
                        </Button>
                      </Box>
                      <Divider></Divider>
                      <Typography
                        sx={{
                          fontSize: 13,
                          fontWeight: 400,
                          py: 1,
                          textAlign: "center",
                          color: "#01008B",
                        }}
                      ></Typography>
                      <CardMedia
                        sx={{
                          height: 200,
                          objectFit: "cover", // or "cover" depending on your need
                          display: "block",
                          width: "100%",
                        }}
                        image={
                          value == 0 ? item.fileForWeb : item.fileForAndroid
                        }
                      />
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                          px: 1,
                          pt: "4px",
                          pb: "4px",
                        }}
                      >
                        <Typography
                          sx={{
                            color: "#01008B",
                            fontWeight: "600",
                            fontSize: "11px",
                          }}
                        >
                          Advertisement Entry date :{" "}
                          {formatDate(item.lastModifiedDate)}
                        </Typography>
                      </Box>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <AddOfferModal open={open} value={value} handleClose={handleClose} />
        <UpdateAdvertisement
          open={openUpdateModal}
          value={value}
          handleClose={handleCloseUpdateModal}
          offerData={selectedOffer}
        />
      </Grid>
    </>
  );
};
